import { render, staticRenderFns } from "./product.vue?vue&type=template&id=e9398128&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=e9398128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9398128",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TfImg: require('/app/components/tf/img.vue').default,ModalCollections: require('/app/components/modal/collections.vue').default,ModalBasic: require('/app/components/modal/basic.vue').default})
